<template>
    <div style="width: 100%;font-weight: normal;">
        <div class="btnBox">
            <div @click="toggleClass(0)" :class="activeIndex == 0 ? 'small_box active' : 'small_box'">组织体系</div>
            <div @click="toggleClass(1)" :class="activeIndex == 1 ? 'small_box active' : 'small_box'">制度建设</div>
            <div @click="toggleClass(2)" :class="activeIndex == 2 ? 'small_box active' : 'small_box'">“六有”服务</div>
            <div @click="toggleClass(3)" :class="activeIndex == 3 ? 'small_box active' : 'small_box'">评价监督</div>
            <div @click="toggleClass(4)" :class="activeIndex == 4 ? 'small_box active' : 'small_box'">加分项</div>
        </div>

        <el-table :data="tableData" @row-click="showInfo" style="width: 100%" :header-cell-style="{
            backgroundColor: '#0E59CB',
            color: '#fff',
        }" :default-sort="{ prop: 'date', order: 'descending' }" ref="singleTable" :highlight-selection-row="false"
            :row-class-name="tableRowClassName">
            <el-table-column prop="pfx" label="评分项" />
            <el-table-column prop="zgfz" label="最高分值" />
            <el-table-column prop="address" label="得分项">
                <template slot-scope="scope">
                    <div :class="scope.row.dfx.length > 1 ? 'listClass listActiveClass' : 'listClass'"
                        v-for="(item, index) in scope.row.dfx" :key="index">{{ item }}</div>
                </template>
            </el-table-column>
            <el-table-column prop="df" label="得分" />
            <el-table-column prop="address" label="失分项">
                <template slot-scope="scope">
                    <div :class="scope.row.sfx.length > 1 ? 'listClass listActiveClass' : 'listClass'"
                        v-for="(item, index) in scope.row.sfx" :key="index">{{ item }}</div>
                </template>
            </el-table-column>
            <el-table-column prop="sf" label="失分" />
        </el-table>

        <div class="btnBox2">
            <div> <i class="icon1"></i> 总分：90分</div>
            <div style="margin-left: 10px;"><i class="icon2"></i> 评定等级：优秀</div>
        </div>

    </div>
</template>
<script>
import pfData from "./data.js";
export default {
    name: '',
    components: {},
    data() {
        return {
            activeIndex: 0,
            tableData: []
        }
    },
    created() { },
    mounted() {
        this.tableData = pfData[this.activeIndex];
        console.log(this.tableData, 888)
    },
    watch: {},
    methods: {
        toggleClass(index) {
            this.activeIndex = index;
            this.tableData = pfData[index];

        },

        //奇偶行背景色不同
        tableRowClassName({ rowIndex }) {
            if ((rowIndex + 1) % 2 === 0) {
                return "warning-row";
            } else {
                return "success-row";
            }
        },
    }
};
</script>
<style lang="scss" scoped>
.table {
    position: relative;
    height: 440px;
}

.yema {
    position: absolute;
    bottom: 20px;
    right: 0;
}

::v-deep.el-table .warning-row {
    background-color: #0f53a5 !important;
    color: #fff !important;
}

::v-deep.el-table .success-row {
    background-color: #193a5c !important;
    color: #fff !important;
}

::v-deep.el-table tbody tr:hover>td {
    background-color: unset !important;
}

::v-deep.el-table__body {
    border-color: #0f53a5 !important;
}

.el-table {
    border-bottom: 1px solid #1763e8;
    border-right: 1px solid #1763e8;
    margin: 0 auto;
}

::v-deep.el-table th {
    border: 1px solid #1763e8 !important;
    border-right: none !important;
    border-bottom: none !important;
}

::v-deep.el-table td {
    border: 1px solid #1763e8;
    height: 20px;
    border-right: none !important;
    border-bottom: none !important;
}

::v-deep .el-table__empty-block {
    background-color: #0e59cb;
}

::v-deep .el-table__empty-text {
    color: #fff;
}

::v-deep .el-table__empty-block {
    background-color: #0e59cb;
}

::v-deep .el-table__empty-text {
    color: #fff;
}


::v-deep .el-carousel__container {
    height: 350px;
}

::v-deep .el-dialog {
    width: 800px;
    min-height: 400px;
    background: url("../../assets/images/dialog_bg2.png") no-repeat;
    background-size: 100% 100%;
    border-radius: 24px;

    color: #fff;
    position: relative;

    overflow-y: auto !important;

}

::v-deep .el-dialog__title {
    color: #fff !important;
    font-size: 20px;
    font-weight: 600;
}

::v-deep .el-dialog__header {
    margin: 0 20px;
    border-bottom: 1px solid #338bea;
}

::v-deep .el-form-item__label {
    color: #fff;
}

::v-deep .el-dialog__body {
    color: #fff;
}

::v-deep .el-form-item {
    margin: 0;
}

::v-deep .el-dialog__body {
    padding: 10px 20px;
}

.value,
.label {
    margin-bottom: 15px;
    font-size: 16px;

    // &.label {
    //   display: inline-block;
    //   width: 100px;

    // }

    &.value {
        color: #338bea;
    }
}

.record {
    color: #fff;
    min-width: 500px;
    max-width: 80%;
    min-height: 30px;
    border-radius: 4px;
    border: 1px solid #4172a5;
    margin: 0 0 0 30px;
    padding: 10px;

    .sss {
        display: flex;
        justify-content: space-between;

        .state {
            padding: 0 5px;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 12px;
            background: #1763e8;
            border-radius: 3px;
        }
    }



    &>div {
        margin-bottom: 10px;
    }

    .files {
        color: #1763e8;
        cursor: pointer;
        margin-top: 10px;
    }
}

.imgwrapper {
    display: flex;
    align-items: flex-start;
}

.dateWrqapper {
    min-width: 500px;
    max-width: 80%;
    margin: 0 0 0 30px;
    padding: 10px;
    color: #fff;
    display: flex;
    justify-content: space-between;
}

::v-deep .tsinfoWrapper p {
    margin: 0;
    padding: 0;
    color: #338bea !important;
    padding: 0 !important;
    text-align: left;
    display: flex;
    justify-content: flex-start;
    text-indent: 0 !important;

    font-size: 16px !important;
    line-height: 24px !important;
}

::v-deep .dateWrqapper {
    padding: 0 !important;
    margin-bottom: 5px !important;
}

.textBar {
    display: flex;
    margin-bottom: 15px;

    .label {
        display: flex;
        width: 80px;
        justify-content: flex-end;
    }

    .value {
        width: 0;
        flex: 1;
    }
}

::v-deep .el-step__icon {
    width: 17px !important;
    height: 17px !important;
}

::v-deep .el-step__title {
    font-size: 14px;
    line-height: 28px;
}

::v-deep .el-step__title.is-process {
    color: #C0C4CC !important;
    font-size: 14px !important;
    font-weight: normal !important;
}

::v-deep .el-table .el-table__cell {
    padding: 3px 0 !important;
}

::v-deep .el-step__icon-inner {
    visibility: hidden !important;
}

.btnBox {
    padding: 3px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 10px;
    border-radius: 5px;
    overflow: hidden;
    border: 1px solid #0e59cb;

    &>div {
        flex: 1;

    }
}

.small_box {
    padding: 0 10px;
    min-width: 120px;
    color: #ffffff;
    font-size: 16px;
    text-align: center;
    height: 36px;
    line-height: 36px;
    border: 1px solid transparent;
    user-select: none;

    &.active {
        background: linear-gradient(180deg, #003a87 0%, rgba(0, 40, 93, 0) 100%);
        box-shadow: inset 0px 0px 10px 0px rgba(39, 144, 255, 0.78);
        border: 1px solid;
        border-image: linear-gradient(180deg,
                rgba(95.00000193715096, 233.00000131130219, 255, 0.6196078658103943),
                rgba(105.00000134110451, 183.00000429153442, 255, 1)) 1 1;
    }
}

::v-deep .el-table .cell {
    padding: 0 !important;
    text-align: center;
}

.listClass {
    text-align: left;
    padding: 5px;
}

.listActiveClass {
    border-bottom: 1px solid #0e59cb
}

.btnBox2 {
    // padding: 3px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 5px;
    overflow: hidden;
    margin-top: 10px;
    color: #fff;
    font-size: 18px;

    &>div {
        flex: 1;
        height: 54px;
        background: #0C3E81;
        border-image: linear-gradient(180deg, rgba(255, 255, 255, 0.30000001192092896), rgba(255, 255, 255, 0)) 1 1;
        border-radius: 5px;
        display: flex;
        justify-content: center;
        align-items: center;

        i.icon1 {
            margin-right: 5px;
            display: inline-block;
            width: 25px;
            height: 24px;
            background: url("../../assets/images/11.png");
            background-size: 100% 100%;
        }

        i.icon2 {
            margin-right: 5px;
            display: inline-block;
            width: 25px;
            height: 24px;
            background: url("../../assets/images/22.png");
            background-size: 100% 100%;
        }
    }
}
</style>
